/**
 * Einfache Formatierung fuer Notizen (Vorschlag zu F-05): Absaetze und
 * Aufzaehlungen - ohne Markdown-Bibliothek und ohne HTML aus dem Text.
 *
 *   Leerzeile      -> neuer Absatz
 *   "- " "* " "• " -> Aufzaehlungspunkt
 *   "1. " "2) "    -> nummerierte Liste
 *
 * Rein; die Darstellung macht `ui/composites/NotizText.tsx`.
 */
export type NotizBlock =
  | { art: 'absatz'; zeilen: string[] }
  | { art: 'liste'; nummeriert: boolean; punkte: string[] };

const PUNKT = /^\s*[-*•]\s+(.*)$/;
const NUMMER = /^\s*\d+[.)]\s+(.*)$/;

export function notizBloecke(text: string): NotizBlock[] {
  const bloecke: NotizBlock[] = [];
  let absatz: string[] = [];

  const absatzAbschliessen = () => {
    if (absatz.length > 0) bloecke.push({ art: 'absatz', zeilen: absatz });
    absatz = [];
  };

  for (const zeile of text.replace(/\r\n?/g, '\n').split('\n')) {
    const punkt = zeile.match(PUNKT);
    const nummer = punkt ? null : zeile.match(NUMMER);

    if (punkt || nummer) {
      absatzAbschliessen();
      const nummeriert = Boolean(nummer);
      const inhalt = (punkt ?? nummer)![1]!;
      const letzte = bloecke[bloecke.length - 1];
      if (letzte?.art === 'liste' && letzte.nummeriert === nummeriert) letzte.punkte.push(inhalt);
      else bloecke.push({ art: 'liste', nummeriert, punkte: [inhalt] });
    } else if (zeile.trim() === '') {
      absatzAbschliessen();
      // Eine Leerzeile beendet auch eine Liste.
      bloecke.push({ art: 'absatz', zeilen: [] });
    } else {
      absatz.push(zeile.trim());
    }
  }
  absatzAbschliessen();

  // Leere Trenner waren nur Grenzen, keine Inhalte.
  return bloecke.filter((b) => b.art === 'liste' || b.zeilen.length > 0);
}

/** Einzeilige Vorschau, z. B. fuer die Aufgabenzeile. */
export function notizVorschau(text: string | undefined, max = 140): string {
  if (!text) return '';
  const flach = text.split('\n').map((z) => z.replace(PUNKT, '• $1').trim()).filter(Boolean).join(' · ');
  return flach.length > max ? `${flach.slice(0, max - 1).trimEnd()}…` : flach;
}
